import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import ProductGallery from "../components/ProductGallery";
import SliderSimilier from "../components/SliderSimilier";
import Footer from "../components/Footer";
import { httpReauest } from "../utils/httpRequest";
import { CDN_BASE_URL } from "../config";
import { CartContext } from "../context/CartContext";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { toast } from "react-toastify";
import { calculateGoldPrice } from "../utils/getPrice";
import { priceComma } from "../utils/priceComma";
import { Helmet } from "react-helmet";
import { BsShare, BsTelegram } from "react-icons/bs";
import { FaTelegramPlane } from "react-icons/fa";
import Header from "components/header";
import { useTranslation } from "react-i18next";
import Reveal from "motion/Reveal";
import ProductComments from "components/ProductComments";
import { FavoriteContext } from "context/FavoriteContext";
import { Heart } from "iconsax-react";

function getFullImageUrl(image) {
  if (!image) return null;
  if (image.startsWith("http")) {
    return image; // اگر خودش کامل بود، همون رو بده
  }
  return CDN_BASE_URL + image; // اگر ناقص بود، اضافه کن
}

const ProductDetailsPage = () => {
  const [productId, setProductId] = useState([]);
  const [subProducts, setsubProducts] = useState();
  const [count, setCount] = useState(1);
  const [loading, setloading] = useState(true);
  const [selected, setselected] = useState();
  const [selectedcolor, setselectedcolor] = useState();
  const [selctedsize, setselctedsize] = useState();
  const [balance, setBalance] = useState();
  const [onCart, setonCart] = useState();
  const [countProduct, setcountProduct] = useState(1);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [ImageGallery, setImageGallery] = useState([]);
  const [selectedStorage, setSelectedStorage] = useState();
  const { name } = useParams();

  const { cart, setCart } = useContext(CartContext);
  const { favorite, setfavorite } = useContext(FavoriteContext);

  const [t, i18] = useTranslation("global");

  async function getId() {
    setloading(true);

    const response = await httpReauest("GET", `/product/${name}`, {}, {});
    const product = response.data.data.product;
    const subproducts = response.data.data.subproducts;

    setProductId(product);
    setsubProducts(subproducts);

    if (subproducts.length) {
      handlecolor(subproducts);
    }

    // ✅ پشتیبانی از هر دو مدل image (String) و images (Array)
    const allImagesSet = new Set();

    // کاور محصول
    if (product.cover) {
      allImagesSet.add(getFullImageUrl(product.cover));
    }

    // تصاویر محصولات فرعی
    subproducts.forEach((item) => {
      if (item.images && Array.isArray(item.images)) {
        item.images.forEach((img) => {
          if (img) allImagesSet.add(getFullImageUrl(img));
        });
      } else if (item.image) {
        allImagesSet.add(getFullImageUrl(item.image));
      }
    });

    setImageGallery(Array.from(allImagesSet));
    setCurrentIndex(0);

    // 🛒 بررسی اگر در سبد خرید هست
    const isoncart = cart?.find((item) => item?._id == response.data.data._id);
    if (isoncart) {
      setonCart(isoncart);
    }

    // 🎨 تعیین رنگ و حافظه پیش‌فرض
    const firstColor = subproducts[0]?.color;
    if (firstColor) {
      const currentColorProducts = subproducts.filter(
        (item) => item.color === firstColor
      );

      const uniqueStorages = [];
      const seenStorages = new Set();

      currentColorProducts.forEach((item) => {
        const storageValue = item.storage || item.size;
        if (storageValue && !seenStorages.has(storageValue)) {
          uniqueStorages.push(item);
          seenStorages.add(storageValue);
        }
      });

      setselectedcolor(firstColor);
      setSizes(uniqueStorages);

      const firstSize = currentColorProducts[0];
      if (firstSize) {
        setSelectedStorage(firstSize.storage || firstSize.size);
        setBalance(firstSize);
      }
    }

    setloading(false);
  }

  function handlecolor(subProducts) {
    const groupedByColor = subProducts?.reduce((acc, item) => {
      if (!acc[item.color]) {
        acc[item.color] = [];
      }
      acc[item.color].push(item);
      return acc;
    }, {});

    if (groupedByColor && Object.keys(groupedByColor).length > 0) {
      const result = Object.entries(groupedByColor)
        .map(([color, products]) => {
          const productWithImage = products.find((item) => item.images?.[0]);
          if (productWithImage) {
            return {
              color,
              image: getFullImageUrl(productWithImage.images[0]),
            };
          }
          return null;
        })
        .filter(Boolean); // حذف null ها

      setColors(result);
    } else {
      console.error("No items grouped by color or groupedByColor is undefined");
    }
  }

  function handleChose(color) {
    const currentColorProducts = subProducts.filter(
      (item) => item.color === color
    );
    const otherColorProducts = subProducts.filter(
      (item) => item.color !== color
    );

    const currentColorImages = [];
    currentColorProducts.forEach((item) => {
      item.images?.forEach((img) => {
        currentColorImages.push(getFullImageUrl(img));
      });
    });

    const otherImages = [];
    otherColorProducts.forEach((item) => {
      item.images?.forEach((img) => {
        otherImages.push(getFullImageUrl(img));
      });
    });

    const allGallery = [...currentColorImages, ...otherImages];
    if (productId?.cover) {
      allGallery.push(getFullImageUrl(productId.cover));
    }

    setImageGallery(allGallery);
    setCurrentIndex(0);

    const uniqueStorages = [];
    const seen = new Set();
    currentColorProducts.forEach((item) => {
      const value = item.storage || item.size;
      if (value && !seen.has(value)) {
        seen.add(value);
        uniqueStorages.push(item);
      }
    });

    setselectedcolor(color);
    setSizes(uniqueStorages);

    const firstMatch = currentColorProducts[0];
    if (firstMatch) {
      setSelectedStorage(firstMatch.storage || firstMatch.size);
      setBalance(firstMatch);
    }
  }

  function handleBalance(e) {
    const foundItem = subProducts.find(
      (item) =>
        item.color === selectedcolor &&
        (item.storage ? item.storage : item?.size) == e
    );
    setBalance(foundItem);
  }

  useEffect(() => {
    getId();
    window.scrollTo({ top: 0 });
  }, [name]);

  function handleAdd() {
    if (balance?.balance === 0) {
      return toast.error("محصول موجود نمیباشد");
    }
    if (subProducts?.length) {
      if (!selectedcolor || !balance) {
        return toast.warn("لطفا قبل سفارش مشخصات را تایین کنید");
      }
      const newCart = {
        name: productId?.name,
        color: selectedcolor,
        size: balance?.storage ? balance?.storage : balance?.size,
        img: balance?.image,
        price: balance?.special_price ? balance?.special_price : balance?.price,
        count: count,
        id: balance?._id,
      };

      const cartExited = cart.find((e) => e.id === newCart.id);
      if (cartExited) {
        if (cartExited.count + newCart.count > balance.balance) {
          return toast.error("محصول به این تعداد نمیباشد");
        }
      }

      setCart((prevCart) => {
        const cartExited2 = prevCart.find((e) => e.id === newCart.id);
        if (cartExited2) {
          return prevCart.map((item) =>
            item.id === cartExited2.id
              ? { ...item, count: item.count + newCart.count }
              : item
          );
        } else {
          return [...prevCart, newCart];
        }
      });
    }
  }

  function handleDelete() {
    const newCart = cart.filter((e) =>
      e._id != selected ? selected?._id : productId?._id
    );
    setCart(newCart);
    setonCart(false);
  }

  function handleAddCount() {
    if (selected) {
      if (selected.balance < countProduct + 1) {
        return toast.error("محصول به این تعداد موجود نیست");
      }
    } else {
      if (productId.balance < countProduct + 1) {
        return toast.error("محصول به این تعداد موجود نیست");
      }
    }

    setcountProduct(countProduct + 1);

    const newCart = cart.filter((e) =>
      e._id != selected ? selected?._id : productId?._id
    );
    const productCard = {
      name: productId.name,
      weight: selected ? selected.weight : productId.weight,
      makingFee: selected ? selected.makingFee : productId.makingFee,
      balance: selected ? selected.balance : productId.balance,
      _id: selected ? selected._id : productId._id,
      img: productId.img,
      isSub: selected?.product ? selected?.product : false,
      count: countProduct + 1,
    };
    newCart.push(productCard);
    setCart(newCart);
  }

  function handleDecreseCount() {
    setcountProduct(countProduct - 1);
    const newCart = cart.filter((e) =>
      e._id != selected ? selected?._id : productId?._id
    );
    const productCard = {
      name: productId.name,
      weight: selected ? selected.weight : productId.weight,
      makingFee: selected ? selected.makingFee : productId.makingFee,
      balance: selected ? selected.balance : productId.balance,
      _id: selected ? selected._id : productId._id,
      img: productId.img,
      isSub: selected?.product ? selected?.product : false,
      count: countProduct - 1,
    };
    newCart.push(productCard);
    setCart(newCart);
  }

  const handleChangeImage = (index) => {
    setCurrentIndex(index);
  };

  const isFavorite = favorite.find((item) => item.url === productId?.url);

  function handleAddFavorite(e) {
    e.preventDefault();
    if (isFavorite) {
      const newCart = favorite.filter((c) => c.url !== productId.url);

      setfavorite(newCart);
    } else {
      setfavorite((cur) => [...cur, productId]);
    }
  }

  // if (loading) {
  //   return <Loading />;
  // }

  return (
    <div className="mt-[108px] lg:mt-[83px]">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{productId?.name}</title>
        <meta name="description" content={productId?.desc} />
        <meta name="og:description" content={productId?.desc} />
        <meta name="og:title" content={productId?.name} />
      </Helmet>{" "}
      <Header />
      {/* {share && (
        <Modal
          open={share}
          onClose={() => setshare(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div dir="rtl" style={style}>
            <ShareModal desktop url={url} setShare={setshare} />
          </div>
        </Modal>
      )}
      {share2 && <ShareModal desktop={false} url={url} setShare={setshare2} />} */}
      <div className=" overflow-hidden  pb-10  bg-white ">
        <div className="lg:grid grid-cols-2  flex flex-col justify-center items-center container">
          <h1 className="font-bold text-[18px] w-full lg:text-[27px] py-2 border-b lg:hidden">
            {i18.language == "fa" ? productId?.name : productId?.name_en}
          </h1>
          <div className=" w-full z-10 ">
            {subProducts?.length && (
              <Reveal>
                <ProductGallery
                  currentIndex={currentIndex}
                  setCurrentIndex={setCurrentIndex}
                  images={ImageGallery}
                />
              </Reveal>
            )}
          </div>
          <div className="col-span-1 w-full lg:p-5">
            <Heart
              onClick={handleAddFavorite}
              className="cursor-pointer"
              size={26}
              color={isFavorite ? "red" : "#000"}
              variant={!isFavorite ? "Linear" : "Bold"}
            />
            <Reveal head>
              <div className="">
                <h1 className="font-bold text-[18px] w-full lg:text-[27px] pb-3 pt-1 border-b hidden lg:block">
                  {i18.language == "fa" ? productId?.name : productId?.name_en}
                </h1>
                <p className="py-3">
                  {" "}
                  {i18.language == "fa" ? productId?.desc : productId?.desc_en}
                </p>
              </div>
            </Reveal>

            <Reveal head>
              <div className="grid gap-[12px] border-t pt-3">
                <div className=" flex-wrap">
                  <span className="font-[500] text-[16px] w-full">
                    <strong> {t("color")}</strong> {selectedcolor}
                  </span>
                  <div className="flex gap-2 items-center mt-2">
                    <div className="flex flex-wrap gap-2">
                      {colors.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => {
                            setselectedcolor(item.color);
                            handleChose(item.color);
                          }}
                          className={`cursor-pointer border rounded p-1 ${
                            selectedcolor === item.color
                              ? "ring-2 ring-blue-500"
                              : ""
                          }`}
                        >
                          <img
                            src={item.image}
                            alt={item.color}
                            className="w-20 h-20 object-cover rounded"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {sizes.length ? (
                  <div className="mt-2">
                    <span className="font-[500] text-[16px] block mb-2">
                      <strong>{t("storage")}</strong> {selectedStorage}
                    </span>
                    <div className="flex flex-wrap gap-3">
                      {sizes.map((item, index) => {
                        const storageValue = item.storage || item.size;
                        const isSelected = selectedStorage === storageValue;

                        return (
                          <button
                            key={index}
                            onClick={() => {
                              setSelectedStorage(storageValue);
                              handleBalance(storageValue);
                            }}
                            className={`rounded-xl p-3 border text-sm transition ${
                              isSelected
                                ? "border-blue-600 ring-2 ring-blue-400 text-blue-800 font-bold"
                                : "border-gray-300 hover:border-blue-400"
                            }`}
                          >
                            <div className="text-center min-w-[70px] px-2">
                              <h4 className="text-[16px] font-bold">
                                {storageValue}
                              </h4>
                              <p className="text-[15px] text-gray-600 mt-1">
                                {item.special_price
                                  ? `${priceComma(item.special_price, 2)} ${t(
                                      "toman"
                                    )}`
                                  : `${priceComma(item.price, 2)} ${t(
                                      "toman"
                                    )}`}
                              </p>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
                {balance && (
                  <span className="bg-gray-200 px-3 py-2 rounded-lg w-fit">
                    {t("balance")} : {balance?.balance}
                  </span>
                )}
              </div>
            </Reveal>
            {/* <Reveal head>
              <div className="my-8 flex gap-2 items-center">
                <Link
                  target="_blank"
                  to="https://wa.me/971501926568"
                  className="btn bg-red-500 text-white"
                >
                  {t("get-price")}
                </Link>
              </div>
            </Reveal> */}

            <div className="my-8 flex gap-2 items-center">
              <span className="py-1 w-fit flex items-center border rounded-full mx-2">
                <button
                  onClick={() => {
                    if (count === balance?.balance || !balance?.balance) {
                      return;
                    } else setCount(count + 1);
                  }}
                  className=" px-2 py-1 "
                >
                  <FaPlus />
                </button>
                <span className="px-2 py-1">{count}</span>
                <button
                  onClick={() => {
                    if (count === 1) {
                      return;
                    } else setCount(count - 1);
                  }}
                  className="px-2 py-1 "
                >
                  <FaMinus />
                </button>
              </span>

              <button onClick={handleAdd} className=" btn btn-primary">
                {t("add-to-cart")}
              </button>
            </div>
          </div>
          <div className="col-span-full mt-6 lg:mt-16 w-full">
            <h3 className="font-bold text-[18px] lg:text-[27px]  border-b pb-3">
              {t("more-desc")}
            </h3>
            <div
              dir="rtl"
              className="lg:text-[16px] text-[14px] pt-3"
              dangerouslySetInnerHTML={{ __html: productId?.more_desc }}
            />
          </div>
          <ProductComments data={productId} />
        </div>

        <div className="w-full   mt-10">
          <span className="font-bold text-black text-[30px] lg:text-[40px] pt-8 text-center mb-6 block ">
            {t("related-products")}
          </span>
          {productId?.category && (
            <SliderSimilier category={productId?.category?.url} />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetailsPage;
